jest.mock("lodash/set", () => jest.fn());
jest.mock("@/pixels/utils/helpers", () => ({
  _isMobile: jest.fn(() => true)
}));

jest.mock("../../../utils", () => {
  const originalModule = jest.requireActual("@/utils");
  return {
    ...originalModule,
    getEnvironment: jest.fn(() => ({ name: "de" }))
  };
});

import { _isMobile } from "@/pixels/utils/helpers";
import set from "lodash/set";
import Vue from "vue";
Vue.$log = { info: jest.fn(), warn: jest.fn(), error: jest.fn() };
global.digitalLink = jest.fn();
global.digitalView = jest.fn();
import Adobe from "@/pixels/providers/adobe";

let digitalData;
global._isMobile = jest.fn();
const digitalLink = global.digitalLink;
const digitalView = global.digitalView;

describe("Adobe", () => {
  // Usamos temporizadores de Jest para simular `setTimeout`
  jest.useFakeTimers();

  beforeEach(() => {
    jest.clearAllMocks();

    // Reiniciamos el objeto digitalData antes de cada test para un estado limpio
    digitalData = {
      application: {},
      page: {
        pageInfo: {},
        pageActivity: {
          link: {}
        }
      },
      user: {
        device: {}
      },
      products: {},
      optimization: {},
      internalCampaign: {}
    };

    Object.defineProperty(window, "digitalData", {
      writable: true,
      value: digitalData,
      pageInstanceID: "de"
    });
  });

  it("`init` debería establecer las constantes iniciales y la información del dispositivo", () => {
    // Configurar el mock de _isMobile para este test
    _isMobile.mockReturnValue(true);
    window.location.hostname = "localhost";

    Adobe.init();

    // Avanzamos los temporizadores de Jest para ejecutar el `setTimeout`
    jest.runAllTimers();

    expect(Vue.$log.info).toHaveBeenCalledWith("🚀 Adobe Launch working");

    // Verificar las llamadas a set para la configuración inicial
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "page.pageInfo.server",
      "localhost"
    );
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "user.device.userAgent",
      navigator.userAgent
    );

    // Verificar las llamadas a _isMobile y las propiedades de digitalData
    expect(_isMobile).toHaveBeenCalled();
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "page.pageInfo.sysEnv",
      "web-movil"
    );
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "user.device.mobile",
      "si"
    );
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "pageInstanceID",
      "de"
    );
  });

  it("`clickTracking` debería establecer el paso y llamar a `digitalLink`", () => {
    const context = {
      mutation: {
        payload: "formulario"
      }
    };

    Adobe.clickTracking(context);
    jest.runAllTimers();

    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "application.step",
      "formulario"
    );
    expect(digitalLink).toHaveBeenCalledWith("App Started");
  });

  it("`clickCTA` debería establecer el nombre del enlace y llamar a `digitalLink`", () => {
    const context = {
      mutation: {
        payload: "enlace-principal"
      }
    };

    Adobe.clickCTA(context);
    jest.runAllTimers();

    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "page.pageActivity.link.name",
      "enlace-principal"
    );
    expect(digitalLink).toHaveBeenCalledWith("interno");
  });

  it("`mensaje` debería manejar el caso por defecto y llamar a `digitalView`", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: "algun-error"
          }
        }
      }
    };

    Adobe.mensaje(context);
    jest.runAllTimers();

    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "page.pageInfo.level2",
      "error tecnico"
    );
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "page.pageInfo.errorPage",
      "error tecnico"
    );
    expect(digitalView).toHaveBeenCalledWith("Page View");
  });

  it("`paso1` debería establecer la página de inicio y llamar a `digitalView`", () => {
    const context = {}; // no se usa payload en este método

    _isMobile.mockReturnValue(false); // Para probar el path `escritorio`
    Adobe.paso1(context);
    jest.runAllTimers();

    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "products.attributes",
      []
    );
    // expect(set).toHaveBeenCalledWith(
    //   window.digitalData,
    //   "application.step",
    //   "completa el formulario jubilacion"
    // );
    //ToDo
    // expect(window.digitalData.page.pageInfo.level1).toEqual("cobrar jubilacion");
    //ToDo
    expect(digitalView).toHaveBeenCalledWith("App Page Visit");
  });

  it("`thank` debería establecer los atributos de página exitosa y llamar a `digitalView`", () => {
    const context = {}; // no se usa payload en este método

    Adobe.thank(context);
    jest.runAllTimers();

    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "page.pageInfo.level2",
      "pagina exitosa"
    );
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "application.state",
      "finalizado"
    );
    expect(set).toHaveBeenCalledWith(
      window.digitalData,
      "application.step",
      "pagina exitosa"
    );
    expect(digitalView).toHaveBeenCalledWith("App Completed");
  });
});
